$('.btn-lateral-filtros-mobile').on('click', function (e) {
  e.preventDefault();
  $('.produtos-lateral').addClass('active');
  $('.gotop').hide();
  $('.contatos-laterais').hide();
});
$('.fecha-lateral-filtros').on('click', function (e) {
  e.preventDefault();
  $('.produtos-lateral').removeClass('active');
  $('.gotop').show();
  $('.contatos-laterais').show();
});
